module.exports = __webpack_public_path__ + "img/sideBarTop.c652ac1c.svg";